import { useCenterPageLayout } from '@commonPackage/hooks';

export function useBindModalCheck() {
  const { hasPCPhoneBindBanner } = useCenterPageLayout();

  return {
    showBindBanner: hasPCPhoneBindBanner,
  };
}
